<template>
  <ul
    id="boss-tab-menu"
    class="tabs boss-tabs-menu-list"
    data-tabs
  >
    <scout-tab-recommendation v-if="isPublishedBy(contractId,jobId)" />
    <scout-tab-search-condition
      v-if="!hasEndedContract(contractId)"
      :job-id="jobId"
    />
    <scout-tab-candidate />
    <scout-tab-scouted v-if="!isFutureContract(contractId)" />
    <scout-tab-reservation v-if="!isFutureContract(contractId)" />
  </ul>
</template>

<script>
import ScoutTabRecommendation from '@/components/molecules/ScoutTabRecommendation'
import ScoutTabScouted from '@/components/molecules/ScoutTabScouted'
import ScoutTabSearchCondition from '@/components/molecules/ScoutTabSearchCondition'
import ScoutTabCandidate from '@/components/molecules/ScoutTabCandidate'
import ScoutTabReservation from '@/components/molecules/ScoutTabReservation'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutTabRecommendation,
    ScoutTabScouted,
    ScoutTabSearchCondition,
    ScoutTabCandidate,
    ScoutTabReservation
  },
  props: {
    jobId: {
      type: Number,
      default: null
    },
    contractId: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'isPublishedBy',
      'hasEndedContract',
      'isFutureContract'
    ])
  }
}
</script>
